import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { uploadLeadAttachment } from '../../../store/slices/leadsSlice';

const AddAttachmentDialog = ({ open, selectedLead, onClose, onUploaded }) => {
  const dispatch = useDispatch();

  const [documentType, setDocumentType] = useState('');
  const [processing, setProcessing] = useState(false);

  const handleClose = () => {
    if (processing) return;
    setDocumentType('');
    onClose();
  };

  const handleSubmit = async () => {
    if (!documentType.trim()) { toast.error('Document type is required'); return; }
    if (!selectedLead?.id) return;

    setProcessing(true);
    try {
      const res = await dispatch(
        uploadLeadAttachment({ leadId: selectedLead.id, document_type: documentType.trim() })
      ).unwrap();

      if (res?.success !== false) {
        toast.success(res?.message || 'Attachment uploaded successfully');
        const uploaded = res?.data ?? res;
        handleClose();
        onUploaded?.(uploaded);
      } else {
        toast.error(res?.message || 'Failed to upload attachment');
      }
    } catch (err) {
      toast.error(err?.message || err || 'Failed to upload attachment');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Add Attachment
        <IconButton
          onClick={handleClose}
          disabled={processing}
          sx={{ position: 'absolute', right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Lead: {selectedLead?.name || selectedLead?.dba_name || '—'}
          </Typography>

          <TextField
            label="Title *"
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
            fullWidth
            disabled={processing}
            placeholder="e.g. voided_check, ein, ssn"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={processing}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!documentType.trim() || processing}
          startIcon={processing ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {processing ? 'Sending...' : 'Send'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddAttachmentDialog;
